import React, { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Layout } from "antd";
import { useForm } from "react-hook-form";
import "./dashboard-layout.scss";
import { Outlet, useLocation, useNavigate } from "react-router";
import ThemeModals from "../components/common/modals/theme-modals/ThemeModals";
import DashboardTopbar from "../components/dashboard/dashboard-topbar/DashboardTopbar";
import DashboardSidebar from "../components/dashboard/dashboard-sidebar/DashboardSidebar";

const { Header, Sider, Content } = Layout;

export default function DashboardLayout() {
  const chartContainer = useRef(null);
  const location = useLocation();
  const [currentRoute, setCurrentRoute] = useState("");
  const [collapsed, setCollapsed] = useState(false);
  const [social, setSocial] = useState(false);
  const navigate = useNavigate();

  const {
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
    control,
    clearErrors,
  } = useForm({
    mode: "onChange",
  });
  const onSubmit = async (data) => {};

  useEffect(() => {
    setCurrentRoute(location.pathname);
  }, [location]);

  const bannerShow = ["/", "/events"];
  const musicShow = [
    "/music",
    "/music-library",
    "/music-detail/2",
    "/hidden-music",
    "/music-detail/1",
  ];

  return (
    <Layout className={"dashboard-layout"}>
      <DashboardSidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      <Layout>
        <DashboardTopbar collapsed={collapsed} setCollapsed={setCollapsed} />
        <Content className={"dashboard-content"}>
          <Container className={"h-100"} fluid>
            <Row className={"h-100"}>
              <Col className={"h-100"} lg={12} xl={12} xxl={12}>
                <Outlet />
              </Col>
            </Row>
          </Container>
          <div className={"box-shadow"}></div>
        </Content>
      </Layout>

      <ThemeModals
        open={social}
        close={setSocial}
        title={"Share"}
        // content={<SocialShare close={setSocial}/>}
      />
    </Layout>
  );
}
